import i18n from "i18next";
import moment from "moment";
import UrlEnum from "../constants/UrlEnum";
import { getAmountAudience, getCpmByStatusCampaign} from "./display";

export const LATINAD_DSP = {id: null, name: 'Latinad', exchange: 'latinad'}
export const MAP_ROUTE = '/map'

  export function getMinimunByCurrency(currency) {
    if (currency === 'USD') {
      return 100
    } else if (currency === 'ARS') {
      return 10000
    } else if (currency === 'COP') {
      return 100000
    } else if (currency === 'GTQ') {
      return 300
    } else if (currency === 'PEN') {
      return 150
    } else if (currency === 'CRC') {
      return 27000
    } else if (currency === 'HNL') {
      return 1000
    } else if (currency === 'NIO') {
      return 1500
    } else if (currency === 'SVC') {
      return 350
    } else if (currency === 'PAB') {
      return 40
    } else if (currency === 'CLF') {
      return 1
    } else if (currency === 'CLP') {
      return 20000
    } else if (currency === 'MXN') {
      return 700
    } else if (currency === 'DOP') {
      return 2000
    } else if (currency === 'UYU') {
      return 1500
    } else {
      return 100;
    }
  }

  export function SeparateNumberFormat(number){
    /*
     Checks if first two characters are "es"
     Possible matches:
      - es (latin american spanish was selected by user)
      - es_ar (argentine spanish was selected by user)
      - es-ES (when no language has been selected it might default to this value)
      - + any spanish variation that could be added in the future or set by the browser
    */
    const isSpanish = i18n.language.substring(0,2) === "es";
    const language = isSpanish ? "es-AR" : "en-US";
    const result = new Intl.NumberFormat(language).format(number)
    return result
  }
  
  export function validateIntegerInput(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) {
      return null;
    }
    
    const parseValue = Math.floor(Number(value));
    if (parseValue < 0) {
      return null;
    }
    
    return parseValue;
  }

  // Calculate hour of impression depending on wednesday
  export function calculateHoursForImpressions(display){
    var wednesdayMinutes = null;
    // (24 * 60 )
    var completeDay = 1440
    if (display.working_hours && display.working_hours.length > 0) {
      var durationMinutes = 0
      for (var i = 0; i < display.working_hours.length; i++) {
        if (display.working_hours[i].day_of_week === 3) {
          wednesdayMinutes = wednesdayMinutes == null ? 0 : wednesdayMinutes
          durationMinutes = moment.utc(moment(display.working_hours[i].end_time, "HH:mm:ss").diff(moment(display.working_hours[i].start_time, "HH:mm:ss"), 'minutes'))._i;
          // This validation is when load for example 23:00 to 1:00
          if(durationMinutes < 0){
            durationMinutes = completeDay + durationMinutes;
          }
          wednesdayMinutes = wednesdayMinutes + durationMinutes;
        }
      }
    }
    return wednesdayMinutes == null ? completeDay : wednesdayMinutes
  }

  export const hasAccessRole = (userRoles, accessRoles) => {

    const userRolesNames = Object.values(userRoles);
    return userRolesNames.some(item => accessRoles.includes(item))
  };

  // Companies selling 100% by impressions never see projected playouts. Missing value = legacy 'cpms'.
  export const isCpmiCompany = user => !!(user && user.company && user.company.cpm_type === 'cpmi');

  export function validateCharLimit(inputLenght, limit, message) {
    if (inputLenght === limit) {
      return {
        validateStatus: "error",
        errorMsg: message,
      };
    }
  }

  //Create url depending on location
  export function getUrl(location, pathname = '', parameters = '') {
    const baseUrls = {
      'planner.staging.latinad.com': 'http://cms.staging.latinad.com/',
      'planner.latinad.com': 'http://cms.latinad.com/',
      'adserver.mediashake.co': 'https://cms.latinad.com/',
      'market.grupovia.com': 'http://grupovia.latinad.com/',
      'publinet.com.ar': 'http://gestor.publinet.com.ar/',
      'publinet.us': 'http://cms.publinet.us/',
      'dooh.territoriodigital.co': 'http://territoriodigital.latinad.com/',
      'dooh.movimagen.uy': 'https://admin.dooh.movimagen.uy/',
      'adserversf.mediashake.co': 'http://gestor.latinad.com/',
      'dooh.duoprint.com.ec': 'https://duoprint.latinad.com/',
      'ssp.yodaooh.com': 'https://cms.yodaooh.com/',
      'dsp.hak-media.com': 'https://gestor.hak-media.com/',
      'ooh.blaster.biz': 'https://admin.ooh.blaster.biz/',
      'ooh.lamediatica.com': 'https://admin.ooh.lamediatica.com/',

      'dv360.latinad.com': 'https://cms.latinad.com/',
    };

    const baseUrl = baseUrls[location.hostname] || 'https://cms.dev.latinad.com/';
    const paramStr = parameters && pathname.includes('login') ? parameters : parameters ? '?' + parameters : '';

    return baseUrl + pathname + paramStr;
  }

  export function getNameWhiteLabel(whiteLabel) {
    if( "latinad" === whiteLabel ) return "Latinad"
    if( "grupoVia"=== whiteLabel ) return "Grupo Via"
    if( "mediaShake"=== whiteLabel ) return "Media Shake"
    if( "smartFit"=== whiteLabel ) return "Smart Fit"
    if( "territorioDigital"=== whiteLabel ) return "Territorio Digital"
    if( "movImagen"=== whiteLabel ) return "Movimagen"
    if( "yoda"=== whiteLabel ) return "Yoda"
    if( "hakMedia"=== whiteLabel ) return "Hak Media"
    if( "blaster"=== whiteLabel ) return "Blaster"
    if( "laMediatica"=== whiteLabel ) return "La Mediatica"
    if( "dv360"=== whiteLabel ) return "DV360"
    return "Latinad"
  }

  export function getDomain(domain) {
    const subDomain = domain.split('.').slice(1).join('.');
    const domainMappings = {
      "fenix.publinet.us": "latinad",
      [UrlEnum.grupoViaHostname]: "grupoVia",
      [UrlEnum.grupoViaSubdomain]: "grupoVia",
      [UrlEnum.mediaShakeHostname]: "mediaShake",
      [UrlEnum.mediaShakeSubdomain]: "mediaShake",
      [UrlEnum.smartFitHostname]: "smartFit",
      [UrlEnum.smartFitSubdomain]: "smartFit",
      [UrlEnum.duoPrintHostname]: "duoPrint",
      [UrlEnum.duoPrintSubdomain]: "duoPrint",
      [UrlEnum.territorioDigitalHostname]: "territorioDigital",
      [UrlEnum.territorioDigitalSubdomain]: "territorioDigital",
      [UrlEnum.movImagenHostname]: "movImagen",
      [UrlEnum.movImagenSubdomain]: "movImagen",
      [UrlEnum.yodaHostname]: "yoda",
      [UrlEnum.yodaSubdomain]: "yoda",
      [UrlEnum.hakMediaHostname]: "hakMedia",
      [UrlEnum.hakSubdomanin]: "hakMedia",
      [UrlEnum.blasterHostname]: "blaster",
      [UrlEnum.blasterSubdomain]: "blaster",
      [UrlEnum.laMediaticaHostname]: "laMediatica",
      [UrlEnum.laMediaticaSubdomain]: "laMediatica",
      [UrlEnum.dv360Hostname]: "dv360",
      [UrlEnum.dv360Subdomain]: "dv360",
    };

    return domainMappings[domain] || domainMappings[subDomain] || "latinad";
  }

  export const calculateValueByCpm = (smart_campaign_cpm, promised_shows, action) => {
    var price = (Math.round((smart_campaign_cpm / 1000) * promised_shows * 100) / 100)
    if(action == "calculate_price"){
      return price
    }
    if(action == "difference_cpm_price"){
      return (smart_campaign_cpm - price)
    }
    if(action == "compare_cpm_impresion"){
     return Math.ceil(((smart_campaign_cpm - price) * 1000)/smart_campaign_cpm)
    }
  };

  export const calculateValueForPrice = (smart_campaign_cpm, promised_shows) => {
    var price = parseFloat(((smart_campaign_cpm / 1000) * promised_shows).toFixed(8));
    return price
  };

  export const metabaseUrl = "https://metabase.latinad.com/public/dashboard/";

  export const poiCategories = [
    {
      id: 1,
      slug: 'bar-and-coffee',
      name: "Bar & Coffee",
      icon: "coffee",
    },
    {
      id: 2,
      slug: 'beauty-care',
      name: "Beauty care",
      icon: "smile",
    },
    {
      id: 3,
      slug: 'education',
      name: "Education",
      icon: "read",
    },
    {
      id: 4,
      slug: 'entertainment',
      name: "Entertainment",
      icon: "play-circle",
    },
    {
      id: 5,
      slug: 'finance',
      name: "Finance",
      icon: "rise",
    },
    {
      id: 6,
      slug: 'health',
      name: "Health",
      icon: "heart",
    },
    {
      id: 7,
      slug: 'institutions',
      name: "Institutions",
      icon: "bank",
    },
    {
      id: 8,
      slug: 'restaurants',
      name: "Restaurants",
      icon: "shop",
    },
    {
      id: 9,
      slug: 'services',
      name: "Services",
      icon: "safety",
    },
    {
      id: 10,
      slug: 'shops',
      name: "Shops",
      icon: "shopping",
    },
    {
      id: 11,
      slug: 'transportation',
      name: "Transportation",
      icon: "branches",
    },
    {
      id: 12,
      slug: 'vehicles',
      name: "Vehicles",
      icon: "car",
    },
  ];
  // Is necessary because doctor not function with name without spaces
  export const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + '...';
  }

  // This function is for create an relation_id auxiliar when there is a smart list
  export const getRelationId = (relationId, indice = null) => {
    if(typeof relationId === 'string' && indice == null)
      relationId = parseInt(relationId.split("_")[0])
    if(indice != null)
      relationId = relationId + "_" + indice + "_SL"
    return relationId
  }

  export const formatNumber = (value, language) => {
      value = value ? value.toString().replace(/[a-zA-Z]/g, '') : ''; // Prevents entering letters
      // Let user keep writing the number until it is valid
      if (value && (value.toString().slice(-1) === '.' || value.toString().slice(-1) === ',')) {
          return value;
      }
      const number = isNaN(Number(value)) ? 0 : Number(value);
      const locale = language === 'es' ? 'es-ES' : 'en-US';
      const formatOptions = {
          style: "decimal",
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
      };
      return new Intl.NumberFormat(locale, formatOptions).format(number);
  }

  export const calculeDaysOfCampaign = (date_from, date_to) => {
    const dateFrom = moment(date_from);
    const dateTo = moment(date_to);
    return dateTo.diff(dateFrom, 'days') + 1;
  }

  export const calculeValuesPerGroup = (groupDisplay, customContents, audience, options = { calculateImpacts: true}) => {
    let investmentGroup = 0;
    let impactsGroup = 0;

    groupDisplay.displays.forEach(display => {
      let filteredContents = customContents.filter(item => item.displayId === display.id);
      filteredContents.forEach(content_display => {
        let cpm = getCpmByStatusCampaign(options.editCampaignActive, options.currentCampaign, display);
        // if(options.currentCampaign) {
        //   const displayAux = options.currentCampaign.contents_displays.find(element => element.display_id === display.id);
        //   cpm = !!displayAux && displayAux.cpm ? displayAux.cpm : content_display.cpm;
        // } else {
        //   cpm = display.smart_campaign_cpm;
        // }

        investmentGroup += calculateValueByCpm(cpm, content_display.promised_shows, "calculate_price");

        if (options.calculateImpacts) {
          impactsGroup += getAmountAudience(audience, content_display.relationId, 'impacts');
        }
      });
    });

    return options.calculateImpacts ? [investmentGroup, impactsGroup] : [investmentGroup];
  }

  export const arraysAreDifferent = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return true;
    return !arr1.every((element, index) => element === arr2[index]);
  }

  export const incrementVersion = (listOfContentsInCampaign, content) => {
    const existingNames = new Set(
      listOfContentsInCampaign.map(item => item.content_version_name || 'V1')
    );
    const numbers = [...existingNames]
      .map(name => {
        const match = /^V(\d+)$/i.exec(name);
        return match ? parseInt(match[1], 10) : NaN;
      })
      .filter(n => !isNaN(n));
    let next = (numbers.length ? Math.max(...numbers) : 1) + 1;
    while (existingNames.has(`V${next}`)) next += 1;
    return `V${next}`;
}

export const getRequiredVersionName = (listOfContentsInCampaign = []) => {
  const flagged = listOfContentsInCampaign.find(c => c.isRequiredVersion);
  if (flagged) return flagged.content_version_name || 'V1';
  const first = listOfContentsInCampaign.find(c => !c.isPlaceholder && c.isRequiredVersion !== false);
  return first ? (first.content_version_name || 'V1') : 'V1';
}

export const getDaysOfWeek = (t) => [
    { label: t('Sunday'), value: 0 },
    { label: t('Monday'), value: 1 },
    { label: t('Tuesday'), value: 2 },
    { label: t('Wednesday'), value: 3 },
    { label: t('Thursday'), value: 4 },
    { label: t('Friday'), value: 5 },
    { label: t('Saturday'), value: 6 },
];

// Convert error to JSON
export const toErrorJson = (err) => {
  try {
    if (!err) return { message: 'Unknown error' };

    // Error nativo
    if (err instanceof Error) {
      const base = {
        name: err.name,
        message: err.message,
        stack: err.stack,
        component: err.component,
      };
      if (err.cause) {
        base.cause = typeof err.cause === 'object' ? String(err.cause) : err.cause;
      }
      return base;
    }

    // Strings u objetos simples
    if (typeof err === 'string') return { message: err };
    if (typeof err === 'object') return { ...err };

    // Otros tipos (número, boolean, etc.)
    return { message: String(err) };
  } catch {
    return { message: 'Unserializable error' };
  }
};

export const isCampaignFinished = (endDate) => {
  if (!endDate) return false;
  return moment(endDate).isBefore(moment(), 'day')
}

export const syncRulesWithCampaignDates = (contentsDisplays, newStartDate, newEndDate) => {
  let rulesCount = 0;

  const updatedContents = contentsDisplays.map(item => {
    let rules = typeof item.rules === 'string' ? JSON.parse(item.rules || "[]") : (item.rules || [])
    if (rules.length === 0) return item
    rulesCount += rules.length
        const updatedRules = rules.map(rule => {
      if (!rule.conditions) return rule
      const updatedConditions = rule.conditions.map(condition => {
        if (condition.type === 'date') {
          return {
            ...condition,
            from_date: newStartDate,
            to_date: newEndDate
          }
        }
        return condition
      })
      return { ...rule, conditions: updatedConditions }
    })
    return {
      ...item,
      rules: typeof item.rules === 'string' ? JSON.stringify(updatedRules) : updatedRules
    }
  })

  return { updatedContents, rulesCount }
}

// A URL input rendered with a fixed "https://" addon holds host + path only, and
// the scheme is concatenated back on submit. Stripping it on every change keeps a
// pasted full URL from becoming "https://https://example.com".
export const stripScheme = (value) => (value || '').replace(/^https?:\/\//i, '').trim()

export const withHttps = (value) => `https://${stripScheme(value)}`
